import(/* webpackMode: "eager" */ "/codebuild/output/src3280402338/src/src/app/global-error.tsx");
